// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 3677 ? "dynamic-import-insitepanel" : chunkId) + "." + {"3677":"f5693def0fbed8d83627","9185":"930abf2a230251a150a2"}[chunkId] + ".js";
};